import { render } from "./IntegrationLogos.vue?vue&type=template&id=5d1ddf88"
import script from "./IntegrationLogos.vue?vue&type=script&lang=js"
export * from "./IntegrationLogos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__